module.exports = __webpack_public_path__ + "img/discount.c0a2df19.svg";